import React from "react"
import Job from "./JobContainerFiles/Job"
import { JobContextProvider } from "./JobContainerFiles/JobContext"

const JobMain = () => {
  return (
    <JobContextProvider>
      <Job />
    </JobContextProvider>
  )
}

export default JobMain
